/**
 * @voltxampere/ui — Blue LED 5mm (Sprint 51-1 polish, dedicated variant)
 *
 * Standard 5mm blue LED — InGaN, V_F ≈ 3.2V at 20mA. Higher forward
 * voltage than red/green; needs proper current-limiting calculation.
 * Used in modern status indicators, cool-color demos.
 *
 * Engine zero-diff invariant honored — schemaType `led`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { led } from "../led.js";
export const ledBlue5mm = {
    id: "led-blue-5mm",
    nameTr: "LED Mavi 5mm (genel)",
    nameEn: "LED Blue 5mm (generic)",
    shortcut: "D",
    category: "active",
    viewBox: led.viewBox,
    terminals: led.terminals,
    defaultLabel: "D",
    defaultValue: "BLUE",
    schemaType: "led",
    defaultParams: {
        is: 1e-12,
        n: 3,
        vForward: 3.2,
        color: "blue",
        package: "T-1¾ (5mm)",
        wavelengthNm: 470,
        luminousIntensityMcd: 200,
    },
    renderSVG: () => led.renderSVG(),
};
//# sourceMappingURL=led-blue-5mm.js.map